import { DialogProps } from '@reach/dialog';
import { FC } from 'react';
import { DocumentWithdrawRequest } from 'src/apis/document-exchange/use-document-withdraw';
import { Button } from 'src/components/buttons-and-actions/button';
import { Stack } from 'src/components/layout/stack';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-countdown';

type Props = Pick<DialogProps, 'onDismiss'> & {
  documentWithdraw: DocumentWithdrawRequest;
};

export const WithdrawDocumentModal: FC<Props> = ({
  documentWithdraw,
  onDismiss,
}) => {
  const seconds = useCountdown();

  return (
    <Modal
      data-testid="withdraw-operator-document-modal"
      title="Withdraw Document"
      onDismiss={onDismiss}
    >
      <Stack gap={2}>
        <p>
          Do you want to withdraw this document? This document will be hidden
          for the shipper.
        </p>
        <Stack flow="column" gap={1} justifyContent="space-between">
          <Button mode="secondary" onClick={onDismiss}>
            Cancel
          </Button>
          <Button
            mode="primary"
            data-testid="withdraw-submit-btn-modal"
            disabled={documentWithdraw.pending || seconds !== 0}
            onClick={documentWithdraw.execute}
          >
            {seconds
              ? `Wait ${seconds}s to proceed...`
              : documentWithdraw.pending
                ? 'Withdrawing...'
                : 'Submit'}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
